import React from "react";
import {
  Show,
  TabbedShowLayout,
  Tab,
  TopToolbar,
  ShowProps,
} from "react-admin";

import SanitizedGrid from "components/SanitizedGrid";
import Summary from "./Summary";
import Financial from "./Financial";
import Student from "./Student";
import TitleBreadcrumb from "components/TitleBreadcrumb";
import CustomFormLabel from "components/CustomFormLabel";
import { Grid } from "@material-ui/core";
import InactiveParentButton from "./components/InactiveParentButton";
import ActivateParentButton from "./components/ActivateParentButton";
import InternalNote from "./InternalNote";
import SharedStudent from "./SharedStudent";

const ParentShowAction = (props: any) => {
  const { data } = props;
  return (
    <TopToolbar>
      {data && (
        <>
          {" "}
          {data.status === "active" ? (
            <InactiveParentButton parentId={data.id} />
          ) : (
            <ActivateParentButton parentId={data.id} />
          )}{" "}
        </>
      )}
    </TopToolbar>
  );
};

const ParentShow = (props: ShowProps) => {
  const { id } = props;

  const breadcrumb = [
    { link: "/parents", title: "Parents" },
    { link: `/parents/${id}`, title: id },
  ];

  return (
    <>
      <TitleBreadcrumb paths={breadcrumb} />
      <CustomFormLabel property={props} isFullName />
      <Show {...props} actions={<ParentShowAction />}>
        <SanitizedGrid container spacing={2}>
          <Grid item xs={12}>
            <TabbedShowLayout>
              <Tab label="Summary">
                <Summary {...props} />
              </Tab>
              <Tab label="Financial">
                <Financial {...props} />
              </Tab>
              <Tab label="Student">
                <Student {...props} />
              </Tab>
              <Tab label="Shared Student">
                <SharedStudent {...props} />
              </Tab>
              <Tab label="Internal Note">
                <InternalNote {...props} />
              </Tab>
            </TabbedShowLayout>
          </Grid>
        </SanitizedGrid>
      </Show>
    </>
  );
};

export default ParentShow;
